/**
 * seyoul-ajax-cart.js — v6.3
 *
 * v6.3 changes (ATC lock + intermittent gift fix):
 *  - Serializes theme form adds so Qikify can finish each gift-goal update
 *    before the next paid product mutates the cart.
 *  - Re-enables the clicked button as soon as Shopify accepts the paid item;
 *    gift settling continues in the background without locking the product UI.
 *  - Waits for two stable cart snapshots and a completed Qikify gift goal
 *    before broadcasting the final cart state.
 *
 * v6.2 changes (toast price with quantity):
 *  - Toast shows the price of this add (unit final price × quantity added).
 * Universal: intercepts cart adds from user ATC flows, then waits for
 * third-party cart programs (Qikify gifts/discounts) to settle before opening.
 *
 * v4.1 changes (mini cart was missing on homepage):
 *  - Top-level try/catch so a single bug doesn't silently kill the whole script
 *  - Visible boot marker in console + window.__seyoulMiniCart for diagnostics
 *  - handleFormATC now uses FormData so quantity/properties survive (product page)
 *  - Mini-cart DOM is injected if missing (covers layouts that don't render it)
 *  - Submit listener tolerates buttons without explicit type="submit"
 */
(function () {
  'use strict';

  try {

  function isTonerPadSalesPage() {
    var path = window.location && window.location.pathname ? window.location.pathname : '';
    var templateName = window.Shopify && window.Shopify.template ? window.Shopify.template.name : '';
    return path === '/pages/toner-pad-sale' || templateName === 'page.toner-pad-sale';
  }

  /* ─── DOM (rendered in theme.liquid, injected here as fallback) ─── */
  var backdrop = document.getElementById('seyoul-mini-cart-backdrop');
  var miniCart = document.getElementById('seyoul-mini-cart');
  if (!backdrop || !miniCart) {
    injectMiniCartDom();
    backdrop = document.getElementById('seyoul-mini-cart-backdrop');
    miniCart = document.getElementById('seyoul-mini-cart');
    if (!backdrop || !miniCart) {
      console.warn('[Seyoul Mini Cart] DOM injection failed — aborting');
      return;
    }
  }

  function injectMiniCartDom() {
    if (!document.body) return;
    if (!document.getElementById('seyoul-mini-cart-backdrop')) {
      var b = document.createElement('div');
      b.id = 'seyoul-mini-cart-backdrop';
      b.style.display = 'none';
      document.body.appendChild(b);
    }
    if (!document.getElementById('seyoul-mini-cart')) {
      var mc = document.createElement('div');
      mc.id = 'seyoul-mini-cart';
      mc.setAttribute('role', 'dialog');
      mc.setAttribute('aria-label', 'ตะกร้าสินค้า');
      mc.style.display = 'none';
      mc.innerHTML = ''
        + '<div class="seyoul-mc__header">'
        +   '<div class="seyoul-mc__header-left">'
        +     '<p class="seyoul-mc__header-label">Seyoul</p>'
        +     '<p class="seyoul-mc__header-title" id="seyoul-mc-title">ตะกร้าสินค้า</p>'
        +   '</div>'
        +   '<button class="seyoul-mc__close" id="seyoul-mc-close" aria-label="ปิด">'
        +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
        +   '</button>'
        + '</div>'
        + '<div class="seyoul-mc__subcount" id="seyoul-mc-subcount" style="display:none"></div>'
        + '<div class="seyoul-mc__divider"></div>'
        + '<div class="seyoul-mc__body" id="seyoul-mc-body">'
        +   '<div class="seyoul-mc__loading"><div class="seyoul-mc__spinner"></div><span>กำลังโหลด...</span></div>'
        + '</div>'
        + '<div class="seyoul-mc__divider"></div>'
        + '<div class="seyoul-mc__footer">'
        +   '<div class="seyoul-mc__total-row" id="seyoul-mc-total-row" style="display:none">'
        +     '<span class="seyoul-mc__total-label">ยอดรวม</span>'
        +     '<span class="seyoul-mc__total-price" id="seyoul-mc-total"></span>'
        +   '</div>'
        +   '<div class="seyoul-mc__actions">'
        +     '<a href="/checkout" class="seyoul-mc__btn seyoul-mc__btn--primary" id="seyoul-mc-checkout">ชำระเงิน</a>'
        +     '<a href="/cart" class="seyoul-mc__btn seyoul-mc__btn--secondary" id="seyoul-mc-view-cart">ดูตะกร้า</a>'
        +     '<button class="seyoul-mc__btn seyoul-mc__btn--ghost" id="seyoul-mc-keep">ช้อปต่อ</button>'
        +   '</div>'
        + '</div>';
      document.body.appendChild(mc);
    }
  }

  var _bodyEl     = document.getElementById('seyoul-mc-body');
  var _titleEl    = document.getElementById('seyoul-mc-title');
  var _totalRow   = document.getElementById('seyoul-mc-total-row');
  var _totalEl    = document.getElementById('seyoul-mc-total');
  var _subcountEl = document.getElementById('seyoul-mc-subcount');

  /* ─── State flags ─── */
  var seyoulHandling    = false; // Blocks native cart drawer
  var formATCInProgress = false; // True when OUR form handler is running
  var userATCIntentUntil = 0;     // Allows GemPages/app ATC fetches immediately after a user click
  var releaseHandlingTimer = 0;
  var settleTimer = 0;
  var pendingMiniCartOpen = false;
  var cartSettlePromise = null;
  var resolveCartSettle = null;
  var formATCQueue = Promise.resolve();
  var miniCartSettleStartedAt = 0;
  var activeCartMutations = 0;
  var lastCartMutationAt = 0;
  var cartStableSignature = '';
  var cartStableCount = 0;
  var cartStableCheckInFlight = false;
  var qikifyCartUpdateInProgress = false;
  var qikifySeenDuringSettle = false;
  var lastQikifyEventAt = 0;
  var lastATCButton = null;
  var lastATCButtonAt = 0;
  var activeATCButtonState = null;
  var atcButtonFeedbackTimer = 0;
  var CART_SETTLE_DELAY = 250;
  var CART_SETTLE_MAX_WAIT = 8000;
  var CART_MIN_QIKIFY_WAIT = 1600;
  var QIKIFY_RUNTIME_GRACE = 3000;
  var CART_QIKIFY_QUIET_DELAY = 450;
  var CART_STABLE_POLLS_REQUIRED = 2;
  var USER_ATC_INTENT_WINDOW = 8000;
  var ATC_SUCCESS_FEEDBACK_DURATION = 900;
  var ATC_ADDING_TEXT = 'กำลังเพิ่ม...';
  var ATC_SUCCESS_TEXT = 'เพิ่มสำเร็จ ✓';

  function setupTonerBogoCleanup() {
    var defaultConfig = {
      enabled: true,
      propertyKey: '_seyoul_toner_bogo',
      propertyValue: 'toner_bogo_199',
      items: [
        { handle: 'toner-pads-seyoul', variantId: 43529944104994 },
        { handle: 'toner-pads-gel-yellow-seyoul', variantId: 43846110216226 }
      ]
    };
    var cfg = window.SeyoulTonerBogoConfig || defaultConfig;
    var items = Array.isArray(cfg.items) ? cfg.items.filter(function (item) {
      return item && item.variantId;
    }) : [];

    if (!cfg.enabled || !items.length || window.SeyoulTonerBogo) return;

    var propertyKey = cfg.propertyKey || defaultConfig.propertyKey;
    var propertyValue = cfg.propertyValue || defaultConfig.propertyValue;
    var syncing = false;
    var currentSync = null;

    function variantId(value) {
      return String(value || '');
    }

    var promoVariantIds = items.map(function (item) {
      return variantId(item.variantId);
    });

    function isPromoVariant(item) {
      return item && promoVariantIds.indexOf(variantId(item.variant_id || item.id)) !== -1;
    }

    function isAutoPromoLine(item) {
      var properties = item && item.properties ? item.properties : {};
      return isPromoVariant(item) && properties[propertyKey] === propertyValue;
    }

    function fetchJson(url, options) {
      return fetch(url, options).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      });
    }

    function getCart() {
      return fetchJson('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
    }

    function changeLine(key, quantity) {
      window.__seyoulTonerBogoInternal = true;
      return fetchJson('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).finally(function () {
        window.__seyoulTonerBogoInternal = false;
      });
    }

    function removeAutoPromoLines(cart) {
      var sequence = Promise.resolve(cart);
      (cart.items || []).forEach(function (line) {
        if (!isAutoPromoLine(line)) return;
        sequence = sequence.then(function () {
          return changeLine(line.key, 0);
        });
      });
      return sequence;
    }

    function sync(options) {
      options = options || {};

      if (syncing) {
        return currentSync || Promise.resolve(null);
      }

      syncing = true;

      currentSync = getCart()
        .then(removeAutoPromoLines)
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('seyoul:toner-bogo:sync', {
            detail: { cart: cart || null, reason: options.reason || 'cleanup' }
          }));
          return cart;
        })
        .catch(function (error) {
          if (!options.silent) console.warn('[Seyoul Toner BOGO]', error);
          return null;
        })
        .finally(function () {
          syncing = false;
          currentSync = null;
        });

      return currentSync;
    }

    window.SeyoulTonerBogo = {
      sync: sync,
      config: cfg
    };
  }

  setupTonerBogoCleanup();

  /* ─── Prevent native cart drawer ─── */
  function patchCartDrawer() {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var el = document.querySelector('cart-drawer-component');
      if (!el) return;
      var origShow = el.showDialog ? el.showDialog.bind(el) : null;
      el.showDialog = function () { if (!seyoulHandling && origShow) origShow(); };
      var origOpen = el.open ? el.open.bind(el) : null;
      el.open = function () { if (!seyoulHandling && origOpen) origOpen(); };
    });
  }

  /* ─── Add-to-cart success toast ───
     Keep the existing ATC workflow intact. The toast is only a display layer
     that reads successful cart/add responses and never mutates button styles. */
  var TOAST_DURATION = 3000;
  var _toastTimer = 0;
  var _toastDisplayTimer = 0;
  var _toastEventsBound = false;
  var lastAddedItemHint = null;
  // Quantity of the most recent /cart/add REQUEST (what the user just added).
  // The add.js response only carries the total line quantity, so the request
  // body is the source of truth for "this add".
  var lastAddRequestQty = 0;
  var lastAddRequestQtyAt = 0;
  var ADD_REQUEST_QTY_WINDOW = 10000;

  function getAddSuccessToastMarkup() {
    return ''
      + '<button type="button" class="seyoul-ast__close" aria-label="ปิด">'
      +   '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>'
      + '</button>'
      + '<p class="seyoul-ast__title">'
      +   '<span class="seyoul-ast__title-icon" aria-hidden="true">'
      +     '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>'
      +   '</span>'
      +   '<span>เพิ่มสินค้าเข้าตะกร้าแล้ว</span>'
      + '</p>'
      + '<div class="seyoul-ast__item">'
      +   '<div class="seyoul-ast__image-wrap"><img class="seyoul-ast__image" alt="" loading="lazy" decoding="async"></div>'
      +   '<div class="seyoul-ast__info">'
      +     '<p class="seyoul-ast__name"></p>'
      +     '<p class="seyoul-ast__variant"></p>'
      +     '<div class="seyoul-ast__price-row">'
      +       '<span class="seyoul-ast__price"></span>'
      +       '<span class="seyoul-ast__compare"></span>'
      +       '<span class="seyoul-ast__qty" style="font-size:.78em;font-weight:600;color:#8a8798;display:none"></span>'
      +     '</div>'
      +   '</div>'
      + '</div>'
      + '<a href="/cart" class="seyoul-ast__view-cart">'
      +   '<span>ดูตะกร้าสินค้า</span>'
      +   '<span class="seyoul-ast__view-cart-icon" aria-hidden="true">→</span>'
      + '</a>';
  }

  function bindToastEvents() {
    if (_toastEventsBound) return;
    document.addEventListener('click', function (e) {
      var target = e.target;
      var closeBtn = target && target.closest ? target.closest('.seyoul-ast__close') : null;
      if (closeBtn || (target && target.id === 'seyoul-add-success-overlay')) {
        e.preventDefault();
        e.stopPropagation();
        hideToast();
      }
    }, true);
    _toastEventsBound = true;
  }

  function injectToastStyles() {
    bindToastEvents();
  }

  function injectToastDom() {
    bindToastEvents();

    var overlay = document.getElementById('seyoul-add-success-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'seyoul-add-success-overlay';
      overlay.className = 'seyoul-ast-backdrop';
      overlay.style.display = 'none';
      document.body.appendChild(overlay);
    }

    var toast = document.getElementById('seyoul-add-success-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'seyoul-add-success-toast';
      toast.className = 'seyoul-ast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      toast.style.display = 'none';
      toast.innerHTML = getAddSuccessToastMarkup();
      document.body.appendChild(toast);
    }

    if (!toast.querySelector('.seyoul-ast__close') ||
        !toast.querySelector('.seyoul-ast__title') ||
        toast.querySelector('.seyoul-ast__title').textContent.trim() !== 'เพิ่มสินค้าเข้าตะกร้าแล้ว') {
      toast.innerHTML = getAddSuccessToastMarkup();
    }

    return toast;
  }

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 0
    });
  }

  function parseAddQtyFromBody(body) {
    try {
      if (body == null) return 0;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return Math.floor(Number(body.get('quantity'))) || 1;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return Math.floor(Number(body.get('quantity'))) || 1;
      }
      if (typeof body === 'string') {
        var value = body.trim();
        if (value.charAt(0) === '{' || value.charAt(0) === '[') {
          var data = JSON.parse(value);
          if (data && Array.isArray(data.items) && data.items.length) {
            return Math.floor(Number(data.items[0].quantity)) || 1;
          }
          if (data) return Math.floor(Number(data.quantity)) || 1;
          return 0;
        }
        var urlMatch = /(?:^|&)quantity=([^&]*)/.exec(value);
        if (urlMatch) return Math.floor(Number(decodeURIComponent(urlMatch[1]))) || 1;
        var multipartMatch = /name="quantity"\s*\r?\n\r?\n\s*(\d+)/.exec(value);
        if (multipartMatch) return Math.floor(Number(multipartMatch[1])) || 1;
        return 1;
      }
    } catch (e) {}
    return 0;
  }

  function rememberAddRequestQty(qty) {
    qty = Math.floor(Number(qty));
    if (isFinite(qty) && qty > 0) {
      lastAddRequestQty = qty;
      lastAddRequestQtyAt = Date.now();
    }
  }

  function captureAddRequestQty(url, resource, init) {
    try {
      if (!isCartAddUrl(url)) return;
      lastAddRequestQty = 0;
      lastAddRequestQtyAt = Date.now();
      if (init && init.body !== undefined && init.body !== null) {
        rememberAddRequestQty(parseAddQtyFromBody(init.body));
        return;
      }
      if (resource && typeof resource.clone === 'function' && typeof resource.text === 'function') {
        resource.clone().text().then(function (text) {
          rememberAddRequestQty(parseAddQtyFromBody(text));
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function getAddedQuantity(item) {
    if (lastAddRequestQty > 0 && Date.now() - lastAddRequestQtyAt <= ADD_REQUEST_QTY_WINDOW) {
      return lastAddRequestQty;
    }
    var quantity = item && Math.floor(Number(item.quantity));
    return quantity > 0 ? quantity : 1;
  }

  function normalizeAddedItemHint(data) {
    if (!data) return null;
    if (Array.isArray(data.items) && data.items.length) return normalizeAddedItemHint(data.items[0]);
    return {
      key: data.key || '',
      id: data.id || data.variant_id || '',
      variant_id: data.variant_id || data.id || '',
      product_title: data.product_title || data.title || data.name || '',
      title: data.title || data.product_title || data.name || '',
      variant_title: data.variant_title || '',
      options_with_values: data.options_with_values || [],
      image: data.image || (data.featured_image && (data.featured_image.url || data.featured_image.src)) || '',
      final_price: data.final_price || data.price || data.line_price || 0,
      original_price: data.original_price || data.compare_at_price || 0,
      quantity: data.quantity || 1
    };
  }

  function rememberAddedItemHint(data) {
    var hint = normalizeAddedItemHint(data);
    if (hint) lastAddedItemHint = hint;
    return hint;
  }

  function readAddedItemFromResponse(response) {
    if (!response || !response.clone || !response.ok) return Promise.resolve(null);
    return response.clone().json().then(rememberAddedItemHint).catch(function () {
      return null;
    });
  }

  function findAddedItemInCart(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (!items.length) return null;
    if (!lastAddedItemHint) return items[0];

    var hint = lastAddedItemHint;
    return items.filter(function (item) {
      if (hint.key && item.key === hint.key) return true;
      if (hint.variant_id && String(item.variant_id || item.id) === String(hint.variant_id)) return true;
      if (hint.id && String(item.id || item.variant_id) === String(hint.id)) return true;
      return false;
    })[0] || items[0];
  }

  function getAddedItemImage(item) {
    var src = item && (item.image || (item.featured_image && (item.featured_image.url || item.featured_image.src)));
    if (!src || typeof src !== 'string') return '';
    return src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_160x160$1$3');
  }

  function getAddedItemTitle(item) {
    return (item && (item.product_title || item.title || item.name)) || 'สินค้า';
  }

  function getAddedItemVariantText(item) {
    if (!item) return '';
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    if (Array.isArray(item.options_with_values)) {
      return item.options_with_values
        .map(function (option) { return option && option.value; })
        .filter(function (value) { return value && value !== 'Default Title'; })
        .filter(Boolean)
        .join(' / ');
    }
    return '';
  }

  function renderToastItem(item) {
    var toast = injectToastDom();
    item = item || lastAddedItemHint;

    var image = toast.querySelector('.seyoul-ast__image');
    var imageWrap = toast.querySelector('.seyoul-ast__image-wrap');
    var name = toast.querySelector('.seyoul-ast__name');
    var variant = toast.querySelector('.seyoul-ast__variant');
    var price = toast.querySelector('.seyoul-ast__price');
    var compare = toast.querySelector('.seyoul-ast__compare');
    var qtyEl = toast.querySelector('.seyoul-ast__qty');
    var imgSrc = getAddedItemImage(item);
    var variantText = getAddedItemVariantText(item);
    var addedQty = getAddedQuantity(item);
    var unitFinal = item && (item.final_price || item.price);
    var unitOriginal = item && (item.original_price || item.compare_at_price);
    var finalPrice = unitFinal ? unitFinal * addedQty : (item && (item.final_line_price || item.line_price));
    var originalPrice = unitOriginal ? unitOriginal * addedQty : 0;

    if (image && imageWrap) {
      if (imgSrc) {
        image.src = imgSrc;
        image.alt = getAddedItemTitle(item);
        imageWrap.style.display = '';
      } else {
        image.removeAttribute('src');
        image.alt = '';
        imageWrap.style.display = 'none';
      }
    }
    if (name) name.textContent = getAddedItemTitle(item);
    if (variant) {
      variant.textContent = variantText;
      variant.style.display = variantText ? '' : 'none';
    }
    if (price) price.textContent = finalPrice ? formatMoney(finalPrice) : '';
    if (compare) {
      compare.textContent = originalPrice && finalPrice && originalPrice > finalPrice ? formatMoney(originalPrice) : '';
      compare.style.display = compare.textContent ? '' : 'none';
    }
    if (qtyEl) {
      qtyEl.textContent = addedQty > 1 ? 'x' + addedQty : '';
      qtyEl.style.display = qtyEl.textContent ? '' : 'none';
    }

    return toast;
  }

  function showToast(itemOrMessage, cart) {
    if (window.location.pathname === '/cart') return;
    var item = typeof itemOrMessage === 'string' ? null : (itemOrMessage || findAddedItemInCart(cart));
    var toast = renderToastItem(item);
    var overlay = document.getElementById('seyoul-add-success-overlay');

    window.clearTimeout(_toastDisplayTimer);
    if (overlay) overlay.style.display = 'block';
    toast.style.display = 'block';
    requestAnimationFrame(function () {
      if (overlay) overlay.classList.add('is-open');
      toast.classList.add('is-open');
    });

    window.clearTimeout(_toastTimer);
    _toastTimer = window.setTimeout(hideToast, TOAST_DURATION);
  }

  function scheduleSuccessToast(item, cart) {
    if (item || cart) {
      showToast(item, cart);
      return;
    }

    fetchCartForSettling()
      .then(function (freshCart) {
        showToast(findAddedItemInCart(freshCart), freshCart);
      })
      .catch(function () {
        showToast(lastAddedItemHint, null);
      });
  }

  function hideToast() {
    window.clearTimeout(_toastTimer);
    var toast = document.getElementById('seyoul-add-success-toast');
    var overlay = document.getElementById('seyoul-add-success-overlay');
    if (!toast) return;
    if (overlay) overlay.classList.remove('is-open');
    toast.classList.remove('is-open');
    _toastDisplayTimer = window.setTimeout(function () {
      if (toast.classList.contains('is-open')) return;
      if (overlay) overlay.style.display = 'none';
      toast.style.display = 'none';
    }, 220);
  }

  /* ─── Open / Close ─── */
  // openMiniCart is preserved as a name so all existing call sites still work;
  // success toast is triggered directly from cart/add success handlers.
  function openMiniCart() {
    restoreATCButtonState();
  }

  function closeMiniCart() {
    // No-op — drawer is hidden. Kept so header/close listeners don't error.
  }

  function openNativeCartDrawer() {
    closeMiniCart();
    // Must unset seyoulHandling — otherwise monkey-patch blocks the drawer from opening
    seyoulHandling = false;
    formATCInProgress = false;
    setTimeout(function () {
      // 1. Try clicking the theme's own cart icon (most reliable — theme JS intercepts this)
      var cartLink = document.querySelector('.action__cart, cart-icon a, [data-cart-drawer-toggle]');
      if (cartLink) { cartLink.click(); return; }

      // 2. Try cart-drawer-component direct methods
      var drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl) {
        var methods = ['open', 'showDialog', 'show', 'openDrawer'];
        for (var i = 0; i < methods.length; i++) {
          if (typeof drawerEl[methods[i]] === 'function') {
            try { drawerEl[methods[i]](); return; } catch (e) {}
          }
        }
      }

      // 3. Dispatch Shopify cart open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    }, 380);
  }

  function setSeyoulHandlingFor(duration) {
    window.clearTimeout(releaseHandlingTimer);
    seyoulHandling = true;
    releaseHandlingTimer = window.setTimeout(function () {
      if (!pendingMiniCartOpen && activeCartMutations === 0) seyoulHandling = false;
    }, duration);
  }

  function getATCButtonTextTarget(btn) {
    if (!btn || !btn.querySelector) return btn;
    return btn.querySelector('.button-text, .gp-content-product-button, [class*="button-text"]') || btn;
  }

  function rememberATCButton(btn) {
    if (!btn) return;
    lastATCButton = btn;
    lastATCButtonAt = Date.now();
  }

  function getRecentATCButton() {
    if (!lastATCButton || Date.now() - lastATCButtonAt > USER_ATC_INTENT_WINDOW) return null;
    return lastATCButton;
  }

  function captureATCButtonState(btn) {
    var target = getATCButtonTextTarget(btn);
    return {
      button: btn,
      target: target,
      html: target ? target.innerHTML : '',
      disabled: !!btn.disabled,
      ariaBusy: btn.getAttribute('aria-busy'),
      styleAttr: btn.getAttribute('style'),
      targetStyleAttr: target && target !== btn ? target.getAttribute('style') : null
    };
  }

  function restoreATCButtonState() {
    window.clearTimeout(atcButtonFeedbackTimer);
    if (!activeATCButtonState) return;

    var state = activeATCButtonState;
    var btn = state.button;
    var target = state.target;

    if (btn && document.documentElement.contains(btn)) {
      if (target && document.documentElement.contains(target)) target.innerHTML = state.html;
      btn.disabled = state.disabled;
      if (state.ariaBusy === null) btn.removeAttribute('aria-busy');
      else btn.setAttribute('aria-busy', state.ariaBusy);
      if (state.styleAttr === null) btn.removeAttribute('style');
      else btn.setAttribute('style', state.styleAttr);
      if (target && target !== btn) {
        if (state.targetStyleAttr === null) target.removeAttribute('style');
        else target.setAttribute('style', state.targetStyleAttr);
      }
      btn.classList.remove('seyoul-atc-feedback', 'seyoul-atc-feedback--success', 'seyoul-atc-feedback--adding');
    }

    activeATCButtonState = null;
  }

  function setATCButtonFeedback(btn, text, mode, disableButton) {
    if (isTonerPadSalesPage()) return;
    if (!btn || !document.documentElement.contains(btn)) return;
    if (!activeATCButtonState || activeATCButtonState.button !== btn) {
      restoreATCButtonState();
      activeATCButtonState = captureATCButtonState(btn);
    }

    var target = getATCButtonTextTarget(btn);
    if (target) target.textContent = text;

    btn.disabled = !!disableButton;
    if (disableButton) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
    btn.classList.add('seyoul-atc-feedback');
    btn.classList.toggle('seyoul-atc-feedback--success', mode === 'success');
    btn.classList.toggle('seyoul-atc-feedback--adding', mode === 'adding');
    // Text-only feedback — keep the button's native brand color untouched
    // (per 2026-07-01 request). No background/border/color overrides.

    window.clearTimeout(atcButtonFeedbackTimer);
    atcButtonFeedbackTimer = window.setTimeout(restoreATCButtonState, CART_SETTLE_MAX_WAIT + 3500);
  }

  function setATCButtonAdding(btn) {
    setATCButtonFeedback(btn, ATC_ADDING_TEXT, 'adding', true);
  }

  function setATCButtonSuccess(btn) {
    setATCButtonFeedback(btn || getRecentATCButton(), ATC_SUCCESS_TEXT, 'success', false);
    window.clearTimeout(atcButtonFeedbackTimer);
    atcButtonFeedbackTimer = window.setTimeout(restoreATCButtonState, ATC_SUCCESS_FEEDBACK_DURATION);
  }

  function armUserATCIntent() {
    userATCIntentUntil = Date.now() + USER_ATC_INTENT_WINDOW;
    setSeyoulHandlingFor(USER_ATC_INTENT_WINDOW);
  }

  function isCartMutationUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(String(url || ''));
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(?:[?#]|$)/.test(String(url || ''));
  }

  function shouldOpenMiniCartForMutation(url) {
    if (window.location.pathname === '/cart') return false;
    if (pendingMiniCartOpen) return true;
    if (!isCartAddUrl(url)) return false;
    if (window.__seyoulTonerBogoInternal) return false;
    return formATCInProgress || Date.now() <= userATCIntentUntil;
  }

  function requestMiniCartAfterCartSettles(reason) {
    if (window.location.pathname === '/cart') return Promise.resolve(null);
    if (!pendingMiniCartOpen) {
      miniCartSettleStartedAt = Date.now();
      pendingMiniCartOpen = true;
      cartStableSignature = '';
      cartStableCount = 0;
      qikifySeenDuringSettle = false;
      cartSettlePromise = new Promise(function (resolve) {
        resolveCartSettle = resolve;
      });
    }
    setSeyoulHandlingFor(CART_SETTLE_MAX_WAIT + 2500);
    scheduleSettleCheck(reason || 'cart-mutation');
    return cartSettlePromise;
  }

  function scheduleSettleCheck(reason) {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () {
      var now = Date.now();
      var elapsed = now - miniCartSettleStartedAt;
      var quietFor = lastCartMutationAt ? now - lastCartMutationAt : CART_SETTLE_DELAY;
      var qikifyQuietFor = lastQikifyEventAt ? now - lastQikifyEventAt : CART_QIKIFY_QUIET_DELAY;

      if (elapsed < CART_MIN_QIKIFY_WAIT && elapsed < CART_SETTLE_MAX_WAIT) {
        scheduleSettleCheck(reason);
        return;
      }

      if ((activeCartMutations > 0 || qikifyCartUpdateInProgress) && elapsed < CART_SETTLE_MAX_WAIT) {
        scheduleSettleCheck(reason);
        return;
      }

      if (quietFor < CART_SETTLE_DELAY && elapsed < CART_SETTLE_MAX_WAIT) {
        scheduleSettleCheck(reason);
        return;
      }

      if (qikifySeenDuringSettle && qikifyQuietFor < CART_QIKIFY_QUIET_DELAY && elapsed < CART_SETTLE_MAX_WAIT) {
        scheduleSettleCheck(reason);
        return;
      }

      verifyStableCartThenOpen(reason);
    }, CART_SETTLE_DELAY);
  }

  function markQikifyActivity(eventName) {
    lastQikifyEventAt = Date.now();
    if (pendingMiniCartOpen) {
      qikifySeenDuringSettle = true;
      scheduleSettleCheck(eventName || 'qikify');
    }
  }

  function bindQikifyCartEvents() {
    [
      'boosterkit-data-updated',
      'boosterkit-line-items-changed',
      'boosterkit-free-gift-added',
      'boosterkit-gift-goal-added',
      'boosterkit-bogo-added',
      'boosterkit-volume-added',
      'boosterkit-bundle-added',
      'boosterkit-cart-attribute-updated',
      'boosterkit-quantity-changed'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        markQikifyActivity(eventName);
      });
    });

    document.addEventListener('boosterkit-trigger-cart-update-start', function () {
      qikifyCartUpdateInProgress = true;
      markQikifyActivity('qikify-update-start');
    });

    document.addEventListener('boosterkit-trigger-cart-update-end', function () {
      qikifyCartUpdateInProgress = false;
      markQikifyActivity('qikify-update-end');
    });
  }

  function cartSignature(cart) {
    var items = (cart.items || []).map(function (item) {
      return {
        key: item.key,
        id: item.id,
        variant_id: item.variant_id,
        quantity: item.quantity,
        final_price: item.final_price,
        final_line_price: item.final_line_price,
        original_line_price: item.original_line_price,
        discounts: item.discounts || item.discount_allocations || [],
        properties: item.properties || {}
      };
    });

    return JSON.stringify({
      item_count: cart.item_count,
      total_price: cart.total_price,
      total_discount: cart.total_discount,
      discount_codes: cart.discount_codes || [],
      cart_level_discount_applications: cart.cart_level_discount_applications || [],
      items: items
    });
  }

  function fetchCartForSettling() {
    return fetch('/cart.js', {
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  function qikifyGiftGoalPending(elapsed) {
    var api = window._BK_API;
    if (!api || typeof api.getGiftGoal !== 'function') {
      var hasRuntime = !!document.querySelector('script[src*="boosterkit"], script[src*="qikify"]');
      return Promise.resolve(hasRuntime && elapsed < QIKIFY_RUNTIME_GRACE);
    }

    return Promise.resolve()
      .then(function () {
        return api.getGiftGoal();
      })
      .then(function (goal) {
        return !!(goal && goal.completed && !goal.isGiftAdded);
      })
      .catch(function () {
        return false;
      });
  }

  function finishCartSettling(cart) {
    window.clearTimeout(settleTimer);
    pendingMiniCartOpen = false;
    openMiniCart();
    renderCartItems(cart || undefined);

    var settleResolve = resolveCartSettle;
    resolveCartSettle = null;
    cartSettlePromise = null;
    window.setTimeout(function () { seyoulHandling = false; }, 150);
    if (settleResolve) settleResolve(cart || null);
  }

  function verifyStableCartThenOpen(reason) {
    if (cartStableCheckInFlight) return;
    cartStableCheckInFlight = true;

    fetchCartForSettling()
      .then(function (cart) {
        var elapsed = Date.now() - miniCartSettleStartedAt;
        return qikifyGiftGoalPending(elapsed).then(function (giftPending) {
          var signature = cartSignature(cart);

          if (signature === cartStableSignature) {
            cartStableCount += 1;
          } else {
            cartStableSignature = signature;
            cartStableCount = 1;
          }

          if ((!giftPending && cartStableCount >= CART_STABLE_POLLS_REQUIRED) ||
              elapsed >= CART_SETTLE_MAX_WAIT) {
            finishCartSettling(cart);
            return;
          }

          scheduleSettleCheck(giftPending ? 'qikify-gift-goal' : (reason || 'cart-stability'));
        });
      })
      .catch(function () {
        if (Date.now() - miniCartSettleStartedAt >= CART_SETTLE_MAX_WAIT) {
          finishCartSettling(null);
        } else {
          scheduleSettleCheck(reason || 'cart-stability');
        }
      })
      .finally(function () {
        cartStableCheckInFlight = false;
      });
  }

  function trackCartMutation(url, promiseLike) {
    if (!isCartMutationUrl(url) || window.__seyoulTonerBogoInternal) return;

    var shouldOpen = shouldOpenMiniCartForMutation(url);
    var shouldToastFromObserver = shouldOpen && !formATCInProgress && isCartAddUrl(url);
    activeCartMutations += 1;
    lastCartMutationAt = Date.now();

    Promise.resolve(promiseLike)
      .then(function (response) {
        var ok = !response || response.ok === undefined || response.ok;
        lastCartMutationAt = Date.now();
        if (ok && shouldOpen) {
          // Explicit form flows own their button. Updating the "most recent"
          // button here can unlock or label the wrong card during rapid taps.
          if (!formATCInProgress) setATCButtonSuccess();
          if (shouldToastFromObserver) {
            readAddedItemFromResponse(response).then(function (item) {
              scheduleSuccessToast(item || lastAddedItemHint, null);
            });
          }
          requestMiniCartAfterCartSettles('cart-mutation');
        } else if (shouldOpen) {
          restoreATCButtonState();
        }
      })
      .catch(function () {
        if (shouldOpen) restoreATCButtonState();
      })
      .finally(function () {
        activeCartMutations = Math.max(0, activeCartMutations - 1);
        lastCartMutationAt = Date.now();
        if (pendingMiniCartOpen) scheduleSettleCheck('cart-mutation');
      });
  }

  /* ─── Render cart ─── */
  var mcCurrentPage = 0;
  var mcAllItems    = [];
  var MC_PER_PAGE   = 4;

  function renderPage(page) {
    if (!_bodyEl || !mcAllItems.length) return;
    var total = Math.ceil(mcAllItems.length / MC_PER_PAGE);
    mcCurrentPage = Math.max(0, Math.min(page, total - 1));
    var pageItems = mcAllItems.slice(mcCurrentPage * MC_PER_PAGE, (mcCurrentPage + 1) * MC_PER_PAGE);

    var fragment = document.createDocumentFragment();
    var itemsDiv = document.createElement('div');
    itemsDiv.className = 'seyoul-mc__items';

    pageItems.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_400x400$1$3')
        : '';
      var lineTotal = (item.final_price * item.quantity / 100).toLocaleString('th-TH', { style: 'currency', currency: 'THB', minimumFractionDigits: 0 });

      var card = document.createElement('div');
      card.className = 'seyoul-mc__item';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'seyoul-mc__item-img-wrap';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc; img.alt = item.product_title;
        img.className = 'seyoul-mc__item-img';
        img.loading = 'lazy'; img.decoding = 'async';
        imgWrap.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'seyoul-mc__item-info';

      var name = document.createElement('p');
      name.className = 'seyoul-mc__item-name';
      name.textContent = item.product_title;

      var priceRow = document.createElement('div');
      priceRow.className = 'seyoul-mc__item-price-row';
      var priceSpan = document.createElement('span');
      priceSpan.className = 'seyoul-mc__item-price';
      priceSpan.textContent = lineTotal;
      priceRow.appendChild(priceSpan);

      if (item.original_price && item.original_price > item.final_price) {
        var origSpan = document.createElement('span');
        origSpan.className = 'seyoul-mc__item-compare';
        origSpan.textContent = (item.original_price * item.quantity / 100).toLocaleString('th-TH', { style: 'currency', currency: 'THB', minimumFractionDigits: 0 });
        priceRow.appendChild(origSpan);
      }

      var qty = document.createElement('p');
      qty.className = 'seyoul-mc__item-qty-badge';
      qty.textContent = 'x' + item.quantity;

      info.appendChild(name); info.appendChild(priceRow); info.appendChild(qty);
      card.appendChild(imgWrap); card.appendChild(info);
      itemsDiv.appendChild(card);
    });

    fragment.appendChild(itemsDiv);

    if (total > 1) {
      var pag = document.createElement('div');
      pag.className = 'seyoul-mc__pagination';
      var prev = document.createElement('button');
      prev.className = 'seyoul-mc__page-btn';
      if (mcCurrentPage === 0) prev.disabled = true;
      prev.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M7 1L1 6L7 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      var pgInfo = document.createElement('span');
      pgInfo.className = 'seyoul-mc__page-info';
      pgInfo.textContent = (mcCurrentPage + 1) + ' / ' + total;
      var next = document.createElement('button');
      next.className = 'seyoul-mc__page-btn';
      if (mcCurrentPage >= total - 1) next.disabled = true;
      next.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M1 1L7 6L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      prev.addEventListener('click', function () { renderPage(mcCurrentPage - 1); });
      next.addEventListener('click', function () { renderPage(mcCurrentPage + 1); });
      pag.appendChild(prev); pag.appendChild(pgInfo); pag.appendChild(next);
      fragment.appendChild(pag);
    }

    _bodyEl.textContent = '';
    _bodyEl.appendChild(fragment);
  }

  function renderCartItems(cartOverride) {
    if (_bodyEl) _bodyEl.innerHTML = '<div class="seyoul-mc__loading"><div class="seyoul-mc__spinner"></div><span>กำลังโหลด...</span></div>';
    if (_totalRow) _totalRow.style.display = 'none';

    (cartOverride ? Promise.resolve(cartOverride) : fetch('/cart.js').then(function (r) { return r.json(); }))
      .then(function (cart) {
        var items = cart.items || [], count = cart.item_count || 0, total = cart.total_price || 0;
        if (_titleEl) _titleEl.textContent = 'ตะกร้าสินค้า (' + count + ' ชิ้น)';
        if (_subcountEl) {
          _subcountEl.textContent = 'ทั้งหมด ' + count + ' รายการ';
          _subcountEl.style.display = (count > 0 && window.innerWidth >= 750) ? 'block' : 'none';
        }
        if (_totalRow && _totalEl && count > 0) {
          _totalEl.textContent = (total / 100).toLocaleString('th-TH', { style: 'currency', currency: 'THB', minimumFractionDigits: 0 });
          _totalRow.style.display = 'flex';
        }
        if (items.length === 0) {
          if (_bodyEl) _bodyEl.innerHTML = '<div class="seyoul-mc__empty"><div class="seyoul-mc__empty-icon">🛍</div><p class="seyoul-mc__empty-text">ยังไม่มีสินค้าในตะกร้า</p></div>';
          return;
        }
        mcAllItems = items; mcCurrentPage = 0;
        renderPage(0);
        updateCartBubble(count);
      })
      .catch(function () {
        if (_bodyEl) _bodyEl.innerHTML = '<div class="seyoul-mc__empty"><p>เกิดข้อผิดพลาด กรุณาลองใหม่</p></div>';
      });
  }

  function updateCartBubble(count) {
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
      el.textContent = count > 0 ? String(count < 100 ? count : '') : '';
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
      if (count > 0) { el.classList.add('cart-bubble--animating'); setTimeout(function () { el.classList.remove('cart-bubble--animating'); }, 600); }
    });
    sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
  }

  /* ─────────────────────────────────────────────
     STRATEGY A: cart mutation observer
     Waits for Qikify/app cart mutations to settle before opening.
     Does NOT read response body — safe, no conflicts.
  ───────────────────────────────────────────── */
  (function interceptFetch() {
    var _orig = window.fetch;
    window.fetch = function (resource, init) {
      var result = _orig.apply(this, arguments);
      var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
      captureAddRequestQty(url, resource, init);
      trackCartMutation(url, result);
      return result;
    };
  })();

  (function interceptXHR() {
    if (!window.XMLHttpRequest) return;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__seyoulCartMutationUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__seyoulCartMutationUrl;
      if (isCartMutationUrl(url) && !window.__seyoulTonerBogoInternal) {
        var shouldOpen = shouldOpenMiniCartForMutation(url);
        var shouldToastFromObserver = shouldOpen && !formATCInProgress && isCartAddUrl(url);
        captureAddRequestQty(url, null, arguments.length ? { body: arguments[0] } : null);
        activeCartMutations += 1;
        lastCartMutationAt = Date.now();
        xhr.addEventListener('loadend', function () {
          var ok = xhr.status >= 200 && xhr.status < 300;
          activeCartMutations = Math.max(0, activeCartMutations - 1);
          lastCartMutationAt = Date.now();
          if (ok && shouldOpen) {
            if (!formATCInProgress) setATCButtonSuccess();
            if (shouldToastFromObserver) {
              try {
                scheduleSuccessToast(rememberAddedItemHint(JSON.parse(xhr.responseText)), null);
              } catch (e) {
                scheduleSuccessToast(lastAddedItemHint, null);
              }
            }
            requestMiniCartAfterCartSettles('cart-mutation');
          } else if (shouldOpen) {
            restoreATCButtonState();
          }
          if (pendingMiniCartOpen) scheduleSettleCheck('cart-mutation');
        }, { once: true });
      }
      return origSend.apply(this, arguments);
    };
  })();

  /* ─────────────────────────────────────────────
     STRATEGY B: Standard Shopify forms (action="/cart/add")
     Prevents native page navigation, does own AJAX
     Uses the same settle gate as app/GemPages ATC flows
  ───────────────────────────────────────────── */
  function isATCForm(form) {
    return form && form.action && form.action.indexOf('/cart/add') !== -1;
  }

  function handleFormATC(form, btn) {
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;
    if (form.__seyoulATCPending) return;

    // FormData preserves quantity, line-item properties (properties[*]),
    // selling_plan, and any custom hidden inputs added by apps.
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');
    form.__seyoulATCPending = true;

    function runQueuedAdd() {
      rememberATCButton(btn);
      if (btn) setATCButtonAdding(btn);
      formATCInProgress = true;
      setSeyoulHandlingFor(CART_SETTLE_MAX_WAIT + 2500);

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (item) {
          form.__seyoulATCPending = false;
          rememberAddedItemHint(item);
          // Paid item is confirmed: release the product controls immediately.
          // Qikify gift work remains serialized via the settle promise below.
          setATCButtonSuccess(btn);
          scheduleSuccessToast(lastAddedItemHint, null);
          return requestMiniCartAfterCartSettles('form-atc');
        })
        .catch(function (err) {
          form.__seyoulATCPending = false;
          restoreATCButtonState();
          console.error('[Seyoul ATC]', err);
          alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
        })
        .finally(function () {
          formATCInProgress = false;
          if (!pendingMiniCartOpen && activeCartMutations === 0) seyoulHandling = false;
        });
    }

    // Qikify gift goals mutate the cart after the paid add. Keeping these
    // user adds sequential prevents overlapping threshold/gift calculations.
    formATCQueue = formATCQueue.then(runQueuedAdd, runQueuedAdd);
  }

  /* ─── Event bindings ─── */
  function bindEvents() {
    // CRITICAL: register submit interception FIRST so that, even if mini-cart
    // UI bindings throw, native /cart/add navigation is still prevented.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isATCForm(form)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = form.querySelector('button[type="submit"], [type="submit"]') ||
                form.querySelector('button[name="add"]') ||
                form.querySelector('button');
      handleFormATC(form, btn);
    }, true);

    // Pre-emptively set seyoulHandling on ANY ATC button click (capture phase)
    // so the native cart drawer doesn't race during AJAX.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(
        '[data-add-to-cart], button[name="add"], form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"]'
      ) : null;
      if (!btn) return;
      rememberATCButton(btn);
      // For a submit button inside a cart-add form, the browser reads `disabled`
      // AFTER click handlers run when deciding whether to fire the form-submit
      // activation behavior. Disabling here cancels the pending submit — no
      // /cart/add request is ever sent (Homepage "Set Combo" / "Products" ATC
      // silently did nothing). Skip the disable; handleFormATC will apply the
      // adding feedback (incl. disable) after it preventDefault-s the submit.
      var isSubmitInATCForm = btn.form && typeof btn.form.action === 'string' &&
        btn.form.action.indexOf('/cart/add') !== -1;
      if (!isSubmitInATCForm) {
        setATCButtonAdding(btn);
      }
      armUserATCIntent();
    }, true);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMiniCart(); });

    // Non-critical UI bindings: guard each in case a button is missing.
    try {
      var closeBtn = document.getElementById('seyoul-mc-close');
      var keepBtn  = document.getElementById('seyoul-mc-keep');
      var viewBtn  = document.getElementById('seyoul-mc-view-cart');
      if (closeBtn) closeBtn.addEventListener('click', closeMiniCart);
      if (backdrop) backdrop.addEventListener('click', closeMiniCart);
      if (keepBtn)  keepBtn.addEventListener('click', closeMiniCart);
      if (viewBtn) {
        viewBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeMiniCart();
          setTimeout(function () { window.location.href = '/cart'; }, 50);
        }, true);
      }
    } catch (err) {
      console.error('[Seyoul Mini Cart] UI binding error:', err);
    }
  }

  /* ─── Init ─── */
  // Bind toast shell early; no layout/content files are touched.
  try { injectToastStyles(); } catch (err) { console.error('[Seyoul Mini Cart] injectToastStyles failed:', err); }
  try { patchCartDrawer(); } catch (err) { console.error('[Seyoul Mini Cart] patchCartDrawer failed:', err); }
  try { bindQikifyCartEvents(); } catch (err) { console.error('[Seyoul Mini Cart] bindQikifyCartEvents failed:', err); }
  try { bindEvents(); }     catch (err) { console.error('[Seyoul Mini Cart] bindEvents failed:', err); }

  // Diagnostic marker. Use in DevTools to confirm the script booted:
  //   window.__seyoulMiniCart  →  { booted: true, version: 'v6.3' }
  window.__seyoulMiniCart = { booted: true, version: 'v6.3', openMiniCart: openMiniCart, showToast: showToast };
  console.log('[Seyoul Mini Cart] v6.3 (queued ATC + gift settle) ready');

  } catch (fatalErr) {
    console.error('[Seyoul Mini Cart] FATAL — script aborted:', fatalErr);
  }

})();
